<template>
    <query-modal
        :success="status.isSuccess"
        :error="status.isError"
        :pending="status.isPending"
        @close="$emit('closeModal')"
    >
        <template #modal>
            <div class="flex justify-center flex-col gap-4">
                <h3 class="font-medium text-lg">
                    Удалить мероприятие {{ heading }}?
                </h3>
                <enter-button
                    class="mx-auto"
                    @click="acceptDelete"
                >
                    Удалить
                </enter-button>
            </div>
        </template>
        <template #success>
            <h3 class="font-medium text-lg">
                Мероприятие удалено
            </h3>
        </template>
        <template #error>
            <h3 class="font-medium text-lg">
                Ошибка. Попробуйте позже
            </h3>
        </template>
    </query-modal>
</template>

<script>
import QueryModal from "@/components/QueryModal";
import EnterButton from "@/components/Enter/Button";
import { deleteEventCard } from "@/api";

export default {
    name: "DeleteEventCard",
    components: { QueryModal, EnterButton },
    props: {
        id: Number,
        heading: String
    },
    data() {
        return {
            status: {
                isSuccess: false,
                isError: false,
                isPending: false
            }
        }
    },
    methods: {
        acceptDelete() {
            return deleteEventCard(this.id)
                .then(response => {
                    this.$emit('acceptDelete')
                    this.status.isSuccess = true
                    return response
                })
                .catch(e => {
                    this.status.isError = true
                    console.log(e)
                })
        }
    }
}
</script>

<style scoped>

</style>